import { http } from './http';
import { ROUTES } from './config';
import type { MyReferralStatus, ReferralRedeemResult, ReferralStats } from '../types/ecommerce';

/**
 * CrmService's referral program client. me/redeem are customer-authenticated; stats is
 * manager+, enforced in-service via [RequireRoles] — same "gateway lets it through, the
 * controller gates it" split loyaltyApi uses.
 */
export const referralsApi = {
  me(): Promise<MyReferralStatus> {
    return http.get(`${ROUTES.referrals}/me`);
  },

  redeem(code: string): Promise<ReferralRedeemResult> {
    return http.post(`${ROUTES.referrals}/redeem`, { code });
  },

  stats(): Promise<ReferralStats> {
    return http.get(`${ROUTES.referrals}/stats`);
  },
};
